const DASHBOARDAPI = {
  TOTALCOUNT: `/count/totalCounts`,
  INWARDCOUNT: `bill/count-by-year-and-month`,
  OUTWARDCOUNT: `outward/count-by-year-and-month`,
  INVOICECOUNT : `invoice/invoice`
};

export default DASHBOARDAPI;
